<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import Stepper from './Stepper.svelte';
    import { isEqual } from 'lodash';

    /**
     * @typedef {Object} Props
     * @property {Number} value
     * @property {Array} [options]
     * @property {String} ariaLabelDecr
     * @property {String} ariaLabelIncr
     * @property {Boolean} [disabled]
     * @property {Function} onChange
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        value,
        options = [],
        ariaLabelDecr,
        ariaLabelIncr,
        disabled = false,
        onChange
    } = $props();

    const step = 1;
    const min = 0;

    let max = $derived(options.length - 1);
    let index = $derived(
        Math.max(
            0,
            options.findIndex(val => isEqual(val, value))
        )
    );

    /**
     * @param {Object} newState
     */
    function handleStepperChange(newState) {
        onChange?.(
            Object.assign({}, newState, {
                value: options[newState.value]
            })
        );
    }
</script>

<Stepper value={index} {min} {max} {step} {ariaLabelDecr} {ariaLabelIncr} {disabled} onChange={handleStepperChange} />
